import BelieveAgreementScreen from 'features/believe/application/BelieveAgreementScreen';
import React from 'react';

export default function BelieveAgreements() {
  return <BelieveAgreementScreen />;
}
